import React, { useContext, useState }  from 'react';
import { Box, Typography, Modal } from '@mui/material';
import { Formik } from 'formik';
import { SymptomDetailsContext } from '../../../../utilities/context';
import generic from '../../../../utilities/clinic questions/genericClincQuestions';
import pathwayQuestionIndex from '../../../../utilities/clinic questions/pathwayQuestionIndex';
import { useEffect } from 'react';
import ExtraFormQuestions from './extraformquestions';
import whichHospital from '../../../../utilities/clinic questions/whichhospital.';
import nonRdcQuestions from '../../../../utilities/clinic questions/nonrdcquestions';
import reportUtils from '../../../../utilities/report/reportutils';
import * as Yup from 'yup'


function ExtraFormQuestionsModal(props){

  const style={
    position: 'absolute',
    top: '50%',
    left: {xs:"37%", sm:"30%"},
    transform: 'translate(-30%, -50%)',
    flex: {xs:"50%", sm:"90%"},
    display:"flex block",
    maxHeight:"90%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow:"scroll"
    };

    const {genericQuestionsAsked, setClinicQuestions}= useContext(SymptomDetailsContext)
    const [formQuestions, setFormQuestions]= useState([])
    const [initialValues, setInitialValues] = useState({})
    const [validationSchema, setValidationSchema] = useState()
    let genericQuestions=genericQuestionsAsked

    useEffect(()=>{
    let questionsForForm=[whichHospital(props.path, props.pathwayType)]
      if (props.pathwayType==="rdc")
        {
        if (!genericQuestions)
          {
          questionsForForm.push(...generic)    
          }
      
        let path = `${props.path}Path`
        if (pathwayQuestionIndex.hasOwnProperty(path))
            {
            questionsForForm.push(...pathwayQuestionIndex[path])
            }
        }
      else
        {
        questionsForForm.push(...nonRdcQuestions)
        }
   

    let initial={}
    let validation = Yup.object(reportUtils.buildValidationsSchema(questionsForForm))
    setValidationSchema(validation)
    questionsForForm.forEach((question)=>{
    initial[(question["label"].replaceAll(" ","_"))]=""})
    setInitialValues(initial)
    setFormQuestions(questionsForForm)},[genericQuestionsAsked, props.path])//refreshes form questions if a previous form with generic questions has been submitted

  const handleClose =()=>{
  props.setModalOpen(false)
  }

return(
<Modal
  open={props.modalOpen}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
     Extra questions for a {props.readablePath} referral
    </Typography>
    <Typography variant='subtext3'></Typography>
   <Box sx={{m:2}}>
    <ExtraFormQuestions initialValues={initialValues} validationSchema = {validationSchema} questions={formQuestions} setClinicQuestions={setClinicQuestions} path={props.path} pathwayType={props.pathwayType} setModalOpen={props.setModalOpen}  setFormSubmitted={props.setFormSubmitted}/>
  </Box>
  </Box>
</Modal>)

}

export default ExtraFormQuestionsModal